import {
  ChainID,
  pathTemplate,
  SUI_ARCHIVE_GRPC_PATH,
} from '@ankr.com/chains-list';

const grpcSuffix = '_grpc';
const kavaPlaceholder = '-rpc';
const ARCHIVE_SUI_GRPC_PATH_CORRECTED = 'archive.sui_grpc';

interface BuildGrpcUrlsParams {
  blockchainID: string;
  grpcUrlTemplate: string;
  paths: string[];
}

export const buildGrpcUrls = ({
  blockchainID,
  grpcUrlTemplate,
  paths,
}: BuildGrpcUrlsParams) => {
  const placeholder =
    blockchainID === ChainID.KAVA_TENDERMINT_GRPC ? kavaPlaceholder : '';

  return paths.map(path => {
    // Corner case for path mapping as it can't be used on the backend side
    // Convert archive_sui_grpc to archive.sui_grpc
    if (path === SUI_ARCHIVE_GRPC_PATH) {
      path = ARCHIVE_SUI_GRPC_PATH_CORRECTED;
    }

    const correctedPath = path.endsWith(grpcSuffix)
      ? path.replace(grpcSuffix, placeholder)
      : path;

    return grpcUrlTemplate.replace(
      pathTemplate,
      // underscores should be replaced with hyphens
      correctedPath.replaceAll('_', '-'),
    );
  });
};
